var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4088_76161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1042 1.88722C9.60484 1.03759 8.39864 1.03759 7.89928 1.88722L0.185204 15.0122C-0.328958 15.887 0.288313 17 1.28766 17H16.7158C17.7152 17 18.3324 15.887 17.8183 15.0122L10.1042 1.88722ZM9 5.75C9.60234 5.75 10.073 6.27007 10.0131 6.86942L9.61847 10.8153C9.5867 11.133 9.31932 11.375 9 11.375C8.68067 11.375 8.4133 11.133 8.38153 10.8153L7.98694 6.86942C7.92701 6.27007 8.39766 5.75 9 5.75ZM9.00173 12.5C9.62305 12.5 10.1267 13.0037 10.1267 13.625C10.1267 14.2463 9.62305 14.75 9.00173 14.75C8.38041 14.75 7.87673 14.2463 7.87673 13.625C7.87673 13.0037 8.38041 12.5 9.00173 12.5Z",
    fill: "#C78300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4088_76161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellow);
export default __webpack_public_path__ + "static/media/warning-yellow.e4f5c36124f3365fd769ef271e330a5a.svg";
export { ForwardRef as ReactComponent };